module.exports = __webpack_public_path__ + "media/images/fonts/Feather-b2469c88d8944b230519b648d1fab31b.ttf";